import { FunctionComponent } from 'react';
import { SearchContext } from 'components/search/SearchContext';
import { SearchResultsPage } from 'components/search/SearchResultsPage';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';

export const CitySearchResults: FunctionComponent = () => {
  const currentMetroArea = useCurrentMetroArea();

  return (
    <SearchContext
      locale={currentMetroArea?.locale}
      currencyCode={currentMetroArea?.currencyCode}
      type="city"
    >
      <SearchResultsPage />
    </SearchContext>
  );
};
